import React from "react";
import {
  Stack,
  Badge,
  BadgeProps,
  Typography,
  Box,
} from "@mui/material";
import theme from "../../assets/theme/theme";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import { toDocTypeSlug } from "../../utils/documentUtils";
import { useDocumentUploadContext } from "../../contexts/DocumentUploadContext";
import { IFolder } from "../../contexts/DocumentContext";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

const DocumentCountBadgeGreen = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    height: 32,
    width: 32,
    right: 0,
    top: 13,
    borderRadius: 16,
    background: theme.palette.success.light,
    color: theme.palette.success.main,
    border: `2px solid ${theme.palette.success.main}`,
    fontSize: 14,
    fontWeight: 600,
  },
}));

const DocumentCountBadgeO = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    height: 32,
    width: 32,
    right: 0,
    top: 13,
    borderRadius: 16,
    background: theme.palette.error.light,
    color: theme.palette.error.dark,
    border: `2px solid ${theme.palette.error.main}`,
    fontSize: 14,
    fontWeight: 600,
  },
}));

export interface Props {
  folder: IFolder;
}
const O1EB1Folder: React.FC<Props> = (props) => {
  // const [blinkStyle, setBlinkStyle] = useState('') // scale-element-2
  const { clearRecentlyUpdatedDocTypeSignal } =
    useDocumentUploadContext();

  const BadgeContent = (
    <>
      {(props.folder.count === 0 ? (
        <DocumentCountBadgeO
          badgeContent={props.folder.count ? props.folder.count : "!"}
        // className={blinkStyle}
        >
          {props.folder.icon}
        </DocumentCountBadgeO>
      ) : (
        <DocumentCountBadgeGreen
          badgeContent={props.folder.count ? props.folder.count : "!"}
        // className={blinkStyle}
        >
          {props.folder.icon}
        </DocumentCountBadgeGreen>
      ))}
    </>
  );

  const onClickDocument = () => {
    logEvent(analytics, "click_folder", { ...props.folder });
    clearRecentlyUpdatedDocTypeSignal();
  };

  return (
    <>
      {props.folder.count > 0 ? (
        <Link
          onClick={onClickDocument}
          to={`/o1-eb1/${toDocTypeSlug(props.folder.title)}`}
        >
          <Box
            className="auto-generated-blog"
            display="inline-block"
            style={{ color: theme.palette.text.secondary }}
            pb={4}
          >
            <Stack
              className="auto-generated-folder"
              spacing={1}
              p="20px"
              position="relative"
              flexBasis="120px"
              justifyContent="center"
              alignItems="center"
              margin="auto"
            >
              <>{BadgeContent}</>
              <Typography textAlign="center">{props.folder.title}</Typography>
            </Stack>
          </Box>
        </Link>
      ) : (
        <Box style={{ color: theme.palette.text.secondary, cursor: "not-allowed" }}>
          <Box
            className="auto-generated-blog"
            display="inline-block"
            style={{ color: theme.palette.text.secondary }}
            pb={4}
          >
            <Stack
              className="auto-generated-folder"
              spacing={1}
              p="20px"
              position="relative"
              flexBasis="120px"
              justifyContent="center"
              alignItems="center"
              margin="auto"
            >
              <>{BadgeContent}</>
              <Typography textAlign="center">{props.folder.title}</Typography>
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};
export default O1EB1Folder;
